export default __webpack_public_path__ + "static/confirmation-8ce66330365c5ddfeaaf7697476605d8.svg";